import React, { useState, useRef, useEffect, useContext } from "react";
import animation from "../assets/home/star animation.gif";
import { Image } from 'semantic-ui-react'
import loaderGif from "../assets/loader.gif";

const StarButton = ({ title, onClickAction, disableStar = false, isGray, width, height, isLoading = false, background = null }) => {
    return <button
        onClick={onClickAction}
        style={{ width: (width ? width : undefined), height: (height ? height : undefined) }}
        className={(background ? background : "yellowbt") + (isGray ? ' graybt' : '')}>
        {!disableStar && (<img className="img1" src={animation} />)}
        <span>{isLoading ? <div className="loaderGif"><Image src={loaderGif} /></div> : title}</span>
        {!disableStar && (<img className="img2" src={animation} />)}
    </button>
};



export default StarButton;
